import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonPrimary, ScrollToTop, NavigationPageTitle , Logo, NavigationHeader } from '@core/index';
import { appButtonType, appRoute } from '@utils/globalConstant';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { useStaticContent } from '@context/StaticContent';
import { useA11y } from '@context/Utils';

export function HomePage() {
  // Context
  const navigate = useNavigate();
  const { staticContentData } = useStaticContent();
  const { tA11yTranslate } = useA11y();

  // States
  const [image, setImage] = useState('');

  // Hooks
  useEffect(() => {
    if (staticContentData && staticContentData.media_image) {
      const findImage = staticContentData.media_image.find(
        (item) => item.image_ref === 'ek_web_reg_introduction_content-1'
      );
      if (findImage) setImage(findImage);
    }
  }, [staticContentData]);

  const onClickActivation = () => {
    navigate(appRoute.ACTIVATION);
  };

  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100">
        <NavigationHeader />
          <AppPageContentWrapper>
            <div className='text-center mb-48'>
              <Logo variant="blue" height='136px' />
            </div>
           <div className='text-center'>
              <NavigationPageTitle
                title="ek_reg_introduction_hdl1"
                desc="ek_reg_introduction_txt1"
                variant="sm"
                headingTag="h1"
              />
            </div>
            <div className="row justify-content-center my-48">
              <div style={{ height: '143px', width: '329px' }}>
                <img
                  className="img-fluid object-fit-cover"
                  src={image.media_url_display}
                  alt={image.alt_text}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-5 col-10 px-0 mx-auto">
                <ButtonPrimary
                  buttonType={appButtonType.PRIMARY}
                  buttonContent={tA11yTranslate('ek_reg_introduction_btn1')}
                  label="ek_reg_introduction_btn1"
                  onClick={onClickActivation}
                />
              </div>
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default HomePage;
